"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.dereferenceOpenAPI = exports.defaultReferenceMergePolicy = void 0;
var json_schema_1 = require("@criteria/json-schema");
var OpenAPIIndex_1 = require("../openapi-index/OpenAPIIndex");
var promises_1 = require("../util/promises");
// default options
exports.defaultReferenceMergePolicy = 'by_keyword';
function dereferenceOpenAPI(openAPI, options) {
    var _a;
    // Index root document
    var index = new OpenAPIIndex_1.OpenAPIIndex({
        cloned: true,
        retrieve: options === null || options === void 0 ? void 0 : options.retrieve,
        defaultJSONSchemaDialect: options === null || options === void 0 ? void 0 : options.defaultJSONSchemaDialect
    });
    var addRootOpenAPIResult = index.addRootOpenAPI(openAPI, (_a = options === null || options === void 0 ? void 0 : options.baseURI) !== null && _a !== void 0 ? _a : '');
    return (0, promises_1.chain)(addRootOpenAPIResult, function () {
        var _a;
        openAPI = index.root();
        var referenceMergePolicy = (_a = options === null || options === void 0 ? void 0 : options.referenceMergePolicy) !== null && _a !== void 0 ? _a : exports.defaultReferenceMergePolicy;
        (0, json_schema_1.dereferenceReferences)(openAPI, index.references, index, function (reference, info, dereferencedValue) {
            var _a = reference, summary = _a.summary, description = _a.description, rest = __rest(_a, ["summary", "description"]);
            var merged = (0, json_schema_1.mergeReference)(rest, info, dereferencedValue, referenceMergePolicy);
            if (summary) {
                merged.summary = summary;
            }
            if (description) {
                merged.description = description;
            }
            return merged;
        });
        return index.root();
    });
}
exports.dereferenceOpenAPI = dereferenceOpenAPI;
